module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAE5JREFUSEtj9AqO+c9AAdi2dgkjPu2MoxaMBhHB9DX4g2hr4A6CvqAoH4xaQLCoGA0i2gcRoUT+f4kIRfUF3soCZPmoBaNBRCgRMtA8iABl81N5AKKePwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-step.png
// module id = VefN
// module chunks = 1